import React from 'react';
import PropTypes from 'prop-types';

import {ErrorMessage, Field, Form} from 'formik';

import {PacFormikInput} from 'pac-platform-ui-components';

import {Box, Group, SimpleGrid} from '@mantine/core';

import SubmitFormGroup from 'components/SubmitFormGroup';

import {DisplayFormikState} from 'components/DisplayFormikState';

const FormComponent = (props) => (
    <React.Fragment>
        <Form onSubmit={props.handleSubmit}>
            <SimpleGrid>
                <Box>
                    <Field
                        type="password"
                        name="new_password"
                        placeholder="New Password"
                        component={PacFormikInput}
                    />
                </Box>

                <Box>
                    <Field
                        type="password"
                        name="confirm_password"
                        placeholder="Confirm Password"
                        component={PacFormikInput}
                    />
                </Box>

                <Box>
                    <Group>
                        <Field id="ts" type="checkbox" name="ts" />
                        <label htmlFor="ts">I Agree to the terms of use</label>
                    </Group>
                    <ErrorMessage name="ts" component="div" />
                </Box>

                <SubmitFormGroup
                    cancelUrl="/"
                    disabled={props.isSubmitting}
                    submitButtonLabel="Change Password"
                />
            </SimpleGrid>
        </Form>

        {false && <DisplayFormikState {...props} />}
    </React.Fragment>
);

FormComponent.propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
};

export default FormComponent;
